import React, {useState, useEffect} from "react";
import axios from "axios";
import Box from "@mui/joy/Box";
import Stack from "@mui/joy/Stack";

import LeaderboardCard from "../components/LeaderboardCard";
import LoadingBox from "../components/LoadingBox";

import './styles/home.css';


function Leaderboard() {
    const [users, setUsers] = useState([]);
    const [loadingUsers, setLoadingUsers] = useState(false);

    useEffect(() => {
        // Users - Top 10
        axios.get("https://pfc-nmgfbpc62q-uc.a.run.app/messages/leaderboard")
            .then(response => {
                setUsers(response.data);
                setLoadingUsers(true);
            })
            .catch(error => console.error(error));
    }, []);

    return (
        <Box className='pattern'>
            <Box className="center">
                { (loadingUsers) ?
                    (
                        <Box>
                            <Stack direction='column' spacing={1}>
                                <LeaderboardCard name='Total Users' time='2 month' users={users}/>
                            </Stack>
                        </Box>
                    )
                    :
                    (<LoadingBox/>)
                }
            </Box>
        </Box>
    );
}

export default Leaderboard;
